const Philosophy = () => {
  const cards = [
    {
      href: '/company',
      image: '/image/philosophy1.jpg',
      alt: '会社情報',
      title: '会社情報 - 株式会社MSK',
      label: 'Profile',
      heading: '会社情報',
    },
    {
      href: '/policy',
      image: '/image/philosophy2.jpg',
      alt: '経営指針',
      title: '経営指針 - 株式会社MSK',
      label: 'Policy',
      heading: '経営指針',
    },
    {
      href: '/security',
      image: '/image/philosophy3.jpg',
      alt: '情報セキュリティ基本方針',
      title: '情報セキュリティ基本方針 - 株式会社MSK',
      label: 'Security',
      heading: '情報セキュリティ基本方針',
    },
    {
      href: '/interview',
      image: '/image/philosophy4.jpg',
      alt: '社長インタビュー',
      title: '社長インタビュー - 株式会社MSK',
      label: 'Message',
      heading: '社長インタビュー',
    },
  ];

  return (
    <div id="philosophy" className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* 左側：理念テキスト */}
          <div className="lg:w-[45%] text-center lg:text-left flex-shrink-0">
            <h2 className="text-3xl md:text-4xl font-bold text-[#89B56B] mb-8 leading-relaxed whitespace-nowrap">
              人に必要とされる人を創る
            </h2>
            <p className="text-sm text-gray-600 leading-[2]">
              株式会社MSKは人に必要とされる人を創ります。<br />
              そして社会から必要とされる会社に成ります。<br />
              それは社会貢献すると同時に私達の存在意義となり、<br />
              社会を豊かにすることだと確信しています。
            </p>
          </div>

          {/* 右側：2x2グリッド */}
          <div className="lg:w-[55%]">
            <div className="grid grid-cols-2 gap-4">
              {cards.map((card, index) => (
                <a
                  key={index}
                  href={card.href}
                  className="group bg-white rounded-xl overflow-hidden shadow-[0_2px_16px_rgba(0,0,0,0.06)] hover:shadow-[0_8px_32px_rgba(137,181,107,0.18)] transition-all duration-400 hover:-translate-y-1 cursor-pointer"
                >
                  <div className="w-full h-32 overflow-hidden bg-[#F0F4EC]">
                    <img
                      src={card.image}
                      alt={card.alt}
                      title={card.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-3 text-center">
                    <p className="text-xs text-[#89B56B] font-semibold tracking-[0.15em] uppercase font-['Inter'] mb-1">
                      {card.label}
                    </p>
                    <h3 className="text-sm font-bold text-gray-700">{card.heading}</h3>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Philosophy;